var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg heart",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,30a1.88,1.88,0,0,1-1.38-.64L2.53,17A9,9,0,0,1,.19,12.81,10.27,10.27,0,0,1,.4,8,8.42,8.42,0,0,1,3.07,4.06,8.13,8.13,0,0,1,6.91,2.14a9,9,0,0,1,4.16.32A9.49,9.49,0,0,1,14.7,4.81L16,6.09l1.28-1.28a10.14,10.14,0,0,1,3.63-2.35,7.84,7.84,0,0,1,4.17-.32A8,8,0,0,1,28.9,4h0A8,8,0,0,1,31.57,8a9.22,9.22,0,0,1,.21,4.8A8,8,0,0,1,29.54,17L17.48,29.46A2,2,0,0,1,16,30ZM8.41,5.23a2.93,2.93,0,0,0-1,.11A4.38,4.38,0,0,0,5.2,6.41,5.16,5.16,0,0,0,3.5,9a6.58,6.58,0,0,0-.22,3.2,6.15,6.15,0,0,0,1.5,2.67L16,26.26,27.19,14.63a5.06,5.06,0,0,0,1.39-2.57,6.51,6.51,0,0,0-.11-3.2A5.69,5.69,0,0,0,26.76,6.3h0a4,4,0,0,0-2.34-1.07,5.9,5.9,0,0,0-2.67.22,7.14,7.14,0,0,0-2.24,1.6L16,10.57,12.35,6.94a5,5,0,0,0-2.24-1.39A4.87,4.87,0,0,0,8.41,5.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f8fef6debf965ab59abaf3e0f24a6dcf.svg";
export { ForwardRef as ReactComponent };